<template>
  <div class="use-quotation-tab">
    <div
      size="small"
      @click="changeTab(item,index)"
      :class="item.value === currentValue ? activeItemClass : ''"
      v-for="(item,index) in list"
      :key="index"
      class="use-quotation-tab--item"
    >
      <slot name="label" :item-data="item">
        {{item.label}}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "usePlatformQuotationSupplierTab",
  props:{
    list:{
      type:Array,
      default:()=>[
        // {label:"干线",value:"gx",},
        // {label:"清关",value:"qg",},
        // {label:"拆柜",value:"cg",},
        // {label:"拖柜",value:"tg",},
        // {label:"派送",value:"ps",},
      ],
    },
    activeItemClass:{
      type:String,
      default:"primary",
    },
    defaultCurrentValue:{
      type:[String,Number],
      default:"",
    },
  },
  data(){
    return {
      currentValue:"",
    }
  },
  watch:{
    defaultCurrentValue:{
      immediate:true,
      handler(newVal){
        this.currentValue = newVal;
      }
    },
  },
  methods:{
    /**
     * 切换
     */
    changeTab(item,index){
      let value =  item.value||"";
      this.setCurrentValue(value)
    },
    setCurrentValue(value){
      this.currentValue = value;
      this.$emit("update:defaultCurrentValue",value);
      this.$emit("change",value);
    },
  },
}
</script>

<style scoped lang="scss">
.use-quotation-tab{
  margin-bottom: 18px;
  &--item{
    width: 100px;
    height: 30px;
    display: inline-block;
    border-radius: 2px;
    background: #EFEFEF;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #141414;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    & + & {
      margin-left: 20px;
    }
  }
  .primary {
    background: #FF4D01;
    color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/usePlatformQuotation/supplierTypeTab.vue